export const LanguageLocalStorageIdentifier = '_mqfl_la';
